export const AcademiReason = [
    {  
		checkbox: true,
		id: "1",
		role: "Teacher",
		reason: "Pregnancy",
		createdDate: "24 May 2024",
        key:1
	},
	{   
		checkbox: true,
		id: "2",
		role: "Student",
		reason: "Fees Unpaid",
		createdDate: "21 May 2024",
        key:2
	},
	{
		checkbox: true,
		id: "3",
		role: "Staff",
		reason: "Complaint",
		createdDate: "16 May 2024",
        key:3
	},
	{
		checkbox: true,
		id: "4",
		role: "Student",
		reason: "Complaint",
		createdDate: "15 May 2024",
        key:4
	},
	{
		checkbox: true,
		id: "5",
		role: "Staff",
		reason: "Complaint",
		createdDate: "28 Apr 2024",
        key:5
	},
	{
		checkbox: true,
		id: "6",
		role: "Student",
		reason: "Fail in all Subject",
		createdDate: "26 Apr 2024",
        key:6
	},
	{
		checkbox: true,
		id: "7",
		role: "Staff",
		reason: "Engage",
		createdDate: "22 May 2024",
        key:7
	},
	{
		checkbox: true,
		id: "8",
		role: "Student",
		reason: "Experience",
		createdDate: "16 Apr 2024",
        key:8
	},
	{
		checkbox: true,
		id: "9",
		role: "Staff",
		reason: "No Improvement",
		createdDate: "14 Apr 2024",
        key:9
	},
	{
		checkbox: true,
		id: "10",
		role: "Staff",
		reason: "Issue in family",
		createdDate: "12 May 2024",
        key:10
	}
];
